import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=b927e7b6&scoped=true"
import script from "./topmenu.vue?vue&type=script&lang=js"
export * from "./topmenu.vue?vue&type=script&lang=js"
import style0 from "./topmenu.vue?vue&type=style&index=0&id=b927e7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b927e7b6",
  null
  
)

export default component.exports